/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SimpleTimeWorkedCalculationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetUnitsNotConfiguredForOvertimeReportsResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getUnitsNotConfiguredForOvertimeReports = (request: SimpleTimeWorkedCalculationRequest, options?: CashRequestOptions) => post<SimpleTimeWorkedCalculationRequest, GetUnitsNotConfiguredForOvertimeReportsResponse>("/proxy/services/squareup.timecards.TimeCalculationService/GetUnitsNotConfiguredForOvertimeReports", request, {...options, rejectOnError: true })